import { render, staticRenderFns } from "./buyInfoEdit.vue?vue&type=template&id=52e9be79&scoped=true"
import script from "./buyInfoEdit.vue?vue&type=script&lang=js"
export * from "./buyInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./buyInfoEdit.vue?vue&type=style&index=0&id=52e9be79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9be79",
  null
  
)

export default component.exports